import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import svgIcons from './svg-icons.mapping';
import { SvgIcon } from '../../shared-interfaces';

@Injectable({
  providedIn: 'root'
})
export class SvgLoaderService {
  private readonly assetsPath = 'assets/icons/';
  private readonly svgIcons: SvgIcon[] = svgIcons;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) { }

  public init(): void {
    for (const svgIcon of this.svgIcons) {
      this.matIconRegistry.addSvgIcon(
        svgIcon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `${this.assetsPath}${svgIcon.file}`
        )
      );
    }
  }
}
